import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
// import { TreeviewConfig, TreeviewItem } from '@samotics/ngx-treeview';
import { InstanceDataService } from '../../../../../../services/instance-data.service';
import { AllowedItems } from '../../../../models/informate/allowed-items';

@Component({
    selector: 'app-instance-sidebar',
    templateUrl: './instance-sidebar.component.html',
    styleUrls: ['./instance-sidebar.component.scss'],
})
export class InstanceSidebarComponent implements OnInit {
    @Input()
    set allowedItem(value: AllowedItems) {
        if (value !== null && value !== undefined) {
            this._allowedItem = value;
            this.cd.markForCheck();
        }
    }
    get allowedItem(): AllowedItems {
        return this._allowedItem;
    }

    @Output() allowedItemType: EventEmitter<string> = new EventEmitter();
    @Output() clickItem = new EventEmitter<any>();

    layer: number;
    items: any[];
    values: string[];
    FirstChild: any;
    SecondchildLayer: any;
    ThirdchildLayer: any;
    selectedFirstChild: any;
    selectedChildSecond: any;
    selectedChildThird: any;
    selectedChildLast: any;
    isShow: boolean = false;
    isShowSecondChild: boolean = false;
    isShowThirdChild: boolean = false;
    isShowHierarchyChild = false;
    isShowHierarchyChildSecond = false;
    isShowHierarchyChildThird = false;
    searchtext: string = '';
    searchtext1: string = '';
    searchtext2: string = '';
    _searchtext: string = '';
    _searchtext1: string = '';
    _searchtext2: string = '';

    public _filterfirst = [];
    public _filtersecond = [];
    public _filterThird = [];
    public filterfirst = [];
    public filtersecond = [];
    public filterThird = [];
    public filterLast = [];

    _allowedItem: AllowedItems;

    constructor(
        private cd: ChangeDetectorRef,
        private instanceDataService: InstanceDataService,
        private elementRef: ElementRef
    ) {}

    ngOnInit(): void {
        let layer = this.layer;
    }

    closeAllModal() {
        this.isShowHierarchyChild = false;
        this.isShowHierarchyChildSecond = false;
        this.isShowHierarchyChildThird = false;
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickInside = this.elementRef.nativeElement.contains(target);
        if (!clickInside) {
            this.closeAllModal();
        }
    }

    @HostListener('window:keydown.esc', ['$event'])
    bigFont(event: KeyboardEvent) {
        event.preventDefault();
        this.closeAllModal();
    }

    showHideAllHierarchyChild(event = true) {
        this.searchtext = '';
        this._searchtext = '';
        this.filterfirst = [];
        this._filterfirst = [];

        if (event) {
            this.isShowHierarchyChild = true;
            this.isShowHierarchyChildSecond = false;
            this.isShowHierarchyChildThird = false;
            this.selectedFirstChild = {};
            this.selectedChildSecond = {};
            this.selectedChildThird = {};
            this.selectedChildLast = {};
        } else {
            this.isShowHierarchyChild = false;
        }
    }

    showHideAllHierarchyChildSecond(event = true) {
        this.searchtext1 = '';
        this._searchtext1 = '';
        this.filtersecond = [];
        this._filtersecond = [];
        if (event) {
            this._filterfirst = [];
            this.filterfirst = [];
            this.isShowHierarchyChildSecond = true;
            this.isShowHierarchyChild = false;
            this.isShowHierarchyChildThird = false;
            this.selectedChildSecond = {};
            this.selectedChildThird = {};
            this.selectedChildLast = {};
        } else {
            this.isShowHierarchyChildSecond = false;
        }
    }

    showHideAllHierarchyChildThird(event = true) {
        this.searchtext2 = '';
        this._searchtext2 = '';
        this.filterThird = [];
        this._filterThird = [];
        if (event) {
            this.filtersecond = [];
            this._filtersecond = [];
            this.isShowHierarchyChildThird = true;
            this.isShowHierarchyChildSecond = false;
            this.isShowHierarchyChild = false;
            this.selectedChildThird = {};
            this.selectedChildLast = {};
        } else {
            this.isShowHierarchyChildThird = false;
        }
    }

    onChangePlantList(filterText: string, id: number) {
        this.filterfirst = this.filterFirstchild(filterText, id);
        this.filterfirst = [...this.filterfirst, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    _onChangePlantList(filterText: string, id: number) {
        this._filterfirst = this.filterFirstchild(filterText, id);
        this._filterfirst = [...this._filterfirst, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    onChangeSecondChild(filterTextSecondChild: string, firstChildid: number, id: number) {
        this.filtersecond = this.filterSecondChild(filterTextSecondChild, firstChildid, id);
        this.filtersecond = [...this.filtersecond, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    _onChangeSecondChild(filterTextSecondChild: string, firstChildid: number, id: number) {
        this._filtersecond = this.filterSecondChild(filterTextSecondChild, firstChildid, id);
        this._filtersecond = [...this._filtersecond, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    onChangeThirdChild(filterTextThirdChild: string, firstchildid: number, secondchildid: number, id: number) {
        this.filterThird = this.filterThirdchild(filterTextThirdChild, firstchildid, secondchildid, id);
        this.filterThird = [...this.filterThird, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    _onChangeThirdChild(filterTextThirdChild: string, firstchildid: number, secondchildid: number, id: number) {
        this._filterThird = this.filterThirdchild(filterTextThirdChild, firstchildid, secondchildid, id);
        this._filterThird = [...this._filterThird, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }

    onChangeLastChild(filterTextThirdChild: string, firstchildid: number, secondchildid: number, id: number) {
        this.filterThird = this.filterThirdchild(filterTextThirdChild, firstchildid, secondchildid, id);
        this.filterThird = [...this.filterThird, { itemId: '', name: 'No data found', allowedItemTypeId: '', allowedItemId: '' }];
    }
    // new add ts
    filterFirstchild(filterText: string, id: number): any[] {
        return this.FirstChild.filter((item) => item.name.toLocaleLowerCase().includes(filterText.toLocaleLowerCase()));
    }

    filterSecondChild(filterTextSecondChild: string, firstChildid: number, id: number): any[] {
        return this.SecondchildLayer.filter((item) => item.name.toLocaleLowerCase().includes(filterTextSecondChild.toLocaleLowerCase()));
        //}
    }

    filterThirdchild(filterTextThirdChild: string, firstChildid: number, secondchildid: number, id: number): any[] {
        return this.ThirdchildLayer.filter((item) => item.name.toLocaleLowerCase().includes(filterTextThirdChild.toLocaleLowerCase()));
    }

    filterChange(value: string): void {
    }

    selectedChange(values: string[]) {
        this.values = values;
    }

    itemSelected(id: string) {
        this.closeAllModal();
        this.layer = 1;
        this.instanceDataService.currentLayer.next(1);
        this.isShowSecondChild = false;
        this.isShowThirdChild = false;
        this.filterfirst = [];
        this.filtersecond = [];
        this.filterThird = [];
        this.filterLast = [];
        this._filterfirst = [];
        this._filtersecond = [];
        this._filterThird = [];
        this.searchtext = '';
        this.searchtext1 = '';
        this.searchtext2 = '';
        this._searchtext = '';
        this._searchtext1 = '';
        this._searchtext2 = '';
        this.selectedChildLast = {};
        this.selectedChildThird = {};
        this.selectedChildSecond = {};
        this.selectedFirstChild = {};
        this.FirstChild = [];
        this.SecondchildLayer = [];
        this.ThirdchildLayer = [];
        this.allowedItemType.emit(id);
        this.FirstChild = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == id).items;
        this.selectedFirstChild = this.allowedItem.allowedItemTypes.find((x) => x.allowedItemTypeId == id);
        if (this.FirstChild?.length > 0) {
            this.isShow = true;
        }
    }

    SeconditemSelected(allowedItem: any, flag?: number) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.layer = 2;
            this.instanceDataService.currentLayer.next(2);
            this.isShowSecondChild = false;
            this.isShowThirdChild = false;
            this.filtersecond = [];
            this.filterThird = [];
            this.filterLast = [];
            this._filtersecond = [];
            this._filterThird = [];
            this.searchtext1 = '';
            this.searchtext2 = '';
            this._searchtext1 = '';
            this._searchtext2 = '';
            this.selectedChildLast = {};
            this.selectedChildThird = {};
            this.ThirdchildLayer = [];
            if (flag) {
                this.clickItem.emit(allowedItem);
            }

            if (allowedItem?.items?.length > 0) {
                this.SecondchildLayer = this.FirstChild.find((x) => x.itemId == allowedItem.itemId).items;
                this.selectedChildSecond = this.FirstChild.find((x) => x.itemId == allowedItem.itemId);
                if (this.SecondchildLayer?.length > 0) {
                    this.isShowSecondChild = true;
                }
            } else {
                this.selectedChildSecond = allowedItem;
            }
        }
    }

    _SeconditemSelected(allowedItem: any) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.isShowSecondChild = false;
            this.isShowThirdChild = false;
            this.filtersecond = [];
            this.filterThird = [];
            this.filterLast = [];
            this._filtersecond = [];
            this._filterThird = [];
            this.searchtext1 = '';
            this.searchtext2 = '';
            this._searchtext1 = '';
            this._searchtext2 = '';
            this.selectedChildLast = {};
            this.selectedChildThird = {};
            this.ThirdchildLayer = [];
            this.instanceDataService.currentLayer.next(2);
            this.clickItem.emit(allowedItem);
            if (allowedItem?.items?.length > 0) {
                const index = this.FirstChild.findIndex((x) => x.itemId === allowedItem.itemId);
                this.FirstChild.splice(index, 1);
                this.FirstChild.unshift(allowedItem);

                this.SecondchildLayer = this.FirstChild.find((x) => x.itemId == allowedItem.itemId).items;
                this.selectedChildSecond = this.FirstChild.find((x) => x.itemId == allowedItem.itemId);
                if (this.SecondchildLayer?.length > 0) {
                    this.isShowSecondChild = true;
                }
            } else {
                this.selectedChildSecond = allowedItem;
            }
            this.isShowHierarchyChild = false;
        }
    }

    ThirditemSelected(allowedItem: any, flag?: number) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.layer = 3;
            this.instanceDataService.currentLayer.next(3);
            this.isShowThirdChild = false;
            this.filterThird = [];
            this.filterLast = [];
            this._filterThird = [];
            this.searchtext2 = '';
            this._searchtext2 = '';
            this.selectedChildLast = {};
            if (flag) {
                this.clickItem.emit(allowedItem);
            }
            if (allowedItem?.items?.length > 0) {
                this.ThirdchildLayer = allowedItem.items;
                this.selectedChildThird = allowedItem;
                if (this.ThirdchildLayer?.length > 0) {
                    this.isShowThirdChild = true;
                }
            } else {
                this.selectedChildThird = allowedItem;
            }
        }
    }

    _ThirditemSelected(allowedItem: any) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.instanceDataService.currentLayer.next(3);
            this.clickItem.emit(allowedItem);
            this.isShowThirdChild = false;
            this.filterThird = [];
            this.filterLast = [];
            this._filterThird = [];
            this.searchtext2 = '';
            this._searchtext2 = '';
            this.selectedChildLast = {};
            const index = this.SecondchildLayer.findIndex((x) => x.itemId === allowedItem.itemId);
            this.SecondchildLayer.splice(index, 1);
            this.SecondchildLayer.unshift(allowedItem);
            if (allowedItem?.items?.length > 0) {
                this.ThirdchildLayer = this.SecondchildLayer.find((x) => x.itemId == allowedItem.itemId).items;
                this.selectedChildThird = this.SecondchildLayer.find((x) => x.itemId == allowedItem.itemId);
                if (this.ThirdchildLayer?.length > 0) {
                    this.isShowThirdChild = true;
                }
            } else {
                this.selectedChildThird = allowedItem;
            }
            this.isShowHierarchyChildSecond = false;
        }
    }

    LastitemSelected(allowedItem: any, flag?: number) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.layer = 4;
            this.instanceDataService.currentLayer.next(4);
            if (flag) {
                this.clickItem.emit(allowedItem);
            }
            this.selectedChildLast = allowedItem;
        }
    }

    _LastitemSelected(allowedItem: any) {
        this.closeAllModal();
        if (allowedItem?.itemId) {
            this.layer = 4;
            this.instanceDataService.currentLayer.next(4);
            this.clickItem.emit(allowedItem);

            const index = this.ThirdchildLayer.findIndex((x) => x.itemId === allowedItem.itemId);
            this.ThirdchildLayer.splice(index, 1);
            this.ThirdchildLayer.unshift(allowedItem);

            this.selectedChildLast = allowedItem;
            this.isShowHierarchyChildThird = false;
        }
    }

    _loadDataBySelected(allowedItem, itemId?: string) {
        let layer = this.instanceDataService.currentLayer.getValue();
        if (layer == 1) {
            this._SeconditemSelected(allowedItem);
        }
        if (layer == 2) {
            this._ThirditemSelected(allowedItem);
        }
        if (layer == 3) {
            this._LastitemSelected(allowedItem);
        }
    }

    _loadDataAfterrefresh(itemId?: string) {
        let layer = this.instanceDataService.currentLayer.getValue();
        if (layer == 1) {
            this.itemSelected(itemId);
        }
        if (layer == 2) {
            let allowedItem = this.FirstChild.find((x) => x.itemId == itemId);
            this._SeconditemSelected(allowedItem);
        }
        if (layer == 3) {
            let allowedItem = this.SecondchildLayer.find((x) => x.itemId == itemId);
            this.ThirditemSelected(allowedItem);
        }
        if (layer == 4) {
            let allowedItem = this.SecondchildLayer.find((x) => x.itemId == itemId);
            this.LastitemSelected(allowedItem);
        }
    }
}
